import React from 'react';
import type { DiscoveryProfileCard } from '../../services/api/discoveryService';
import './MatchModal.css';

interface MatchModalProps {
  matchedProfile: DiscoveryProfileCard;
  currentUserName?: string;
  currentUserPhotoUrl?: string;
  onSendMessage: () => void;
  onKeepBrowsing: () => void;
  onClose: () => void;
}

export const MatchModal: React.FC<MatchModalProps> = ({
  matchedProfile,
  currentUserName,
  currentUserPhotoUrl,
  onSendMessage,
  onKeepBrowsing,
  onClose,
}) => {
  const matchPhoto =
    matchedProfile.photos?.find((p) => p.isPrimary)?.url ?? matchedProfile.photos?.[0]?.url;
  const youLabel = currentUserName || 'You';

  return (
    <div
      className="match-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="It's a match"
    >
      <div className="match-modal" onClick={(e) => e.stopPropagation()}>
        <div className="match-modal-header">
          <h2>It's a match!</h2>
          <p>
            <strong>{youLabel}</strong> and <strong>{matchedProfile.displayName}</strong> liked
            each other
          </p>
        </div>

        {/* NPC-voiced icebreaker (WU-B3 / §6.3). Rendered verbatim from the
            backend; omitted when absent so the modal is unchanged. */}
        {matchedProfile.icebreaker && (
          <p className="match-modal-icebreaker">
            <span aria-hidden="true">💫</span> {matchedProfile.icebreaker}
          </p>
        )}

        <div className="match-modal-photos">
          {currentUserPhotoUrl ? (
            <img className="match-modal-photo" src={currentUserPhotoUrl} alt={youLabel} />
          ) : (
            <div className="match-modal-photo match-modal-photo-placeholder">
              {youLabel.charAt(0).toUpperCase()}
            </div>
          )}
          <span className="match-modal-heart" aria-hidden="true">❤</span>
          {matchPhoto ? (
            <img className="match-modal-photo" src={matchPhoto} alt={matchedProfile.displayName} />
          ) : (
            <div className="match-modal-photo match-modal-photo-placeholder">
              {matchedProfile.displayName.charAt(0).toUpperCase()}
            </div>
          )}
        </div>

        <div className="match-modal-actions">
          <button className="match-modal-btn-message" onClick={onSendMessage}>
            Send a message
          </button>
          <button className="match-modal-btn-browse" onClick={onKeepBrowsing}>
            Keep browsing
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchModal;
